import { render, staticRenderFns } from "./index-header.vue?vue&type=template&id=469a495a&scoped=true"
import script from "./index-header.vue?vue&type=script&lang=js"
export * from "./index-header.vue?vue&type=script&lang=js"
import style0 from "./index-header.vue?vue&type=style&index=0&id=469a495a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469a495a",
  null
  
)

export default component.exports